import { useWindowDimensions } from 'react-native';
import { useIsWeb } from './useIsWeb';

/**
 * Hook to determine the current screen breakpoint based on width.
 * Breakpoints:
 * - Small: < 768px
 * - Medium: 768px - 1023px
 * - Large: >= 1024px
 */
export const useBreakpoint = (): {
  isSmallScreen: boolean;
  isMediumScreen: boolean;
  isLargeScreen: boolean;
} => {
  const isWeb = useIsWeb();
  const { width } = useWindowDimensions();

  if (!isWeb) {
    return {
      isSmallScreen: true,
      isMediumScreen: false,
      isLargeScreen: false,
    };
  }

  const isSmallScreen = width < 768;
  const isMediumScreen = width >= 768 && width < 1024;
  const isLargeScreen = width >= 1024;

  return { isSmallScreen, isMediumScreen, isLargeScreen };
};
